import { Epos } from "../Model/Epos.Model";
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eposFilter',
  standalone: false
})
export class EposFilterPipe implements PipeTransform {
  transform(eposList: Epos[], searchTerm: string, field?: string): Epos[] {
    if (!eposList || !searchTerm?.trim()) {
      return eposList;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return eposList.filter(item => {
      if (field && item[field] != null) {
        const value = this.formatValue(item[field]);
        return value.includes(lowerSearch);
      }

      const searchableFields = [
        'bannerName',
        'isPromo',
        'value',
        'valuePromo',
        'volumePromo',
        'averageSkuPrice',
        'weightedDistributionWithDisplay',
        'periodStart',
        'periodEnd',
        'eposFactCode'
      ];

      return searchableFields.some(key => {
        const value = this.formatValue(item[key]);
        return value.includes(lowerSearch);
      });
    });
  }

  private formatValue(value: any): string {
    if (value == null) return '';
    // Convert boolean or number to string; otherwise, assume value is already a string
    return value.toString().toLowerCase();
  }
}
